module.exports = __webpack_public_path__ + "img/cruzeiro-americas.9b0e360f.png";